import type { Dispatch } from "@reduxjs/toolkit";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import { api } from "../../../api/client";
import type { InboxActions } from "./actions";
import { InboxStructureActionsEnum } from "./actions";
import { InboxStructureLoadingEnum } from "./types";

type InboxStructureDispatch = Dispatch<InboxActions>;

const getInboxStructure = withErrorHandling(api.inboxStructure.load);

export function loadInboxStructure(handleErrors = false) {
  return async (dispatch: InboxStructureDispatch) => {
    let state: InboxStructureLoadingEnum;

    const [inboxStructure, error] = await getInboxStructure();

    if (error) {
      logError(error, "[loadInboxStructure]");
      state = InboxStructureLoadingEnum.Error;
    } else {
      dispatch({ type: InboxStructureActionsEnum.Loaded, payload: inboxStructure });
      state = InboxStructureLoadingEnum.Loaded;
    }

    if (handleErrors) {
      dispatch({ type: InboxStructureActionsEnum.UpdateLoading, payload: state });
    }
  };
}
